/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */

import { Injectable, inject } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { OSKHttpsSuccessResponse } from '@oskey/core';

@Injectable({
  providedIn: 'root'
})
export class OSKFirebaseHttpsService {
  private functions: Functions = inject(Functions);

  /**
   * Generic function that calls the {@link HttpsCallable} function with the given name and data
   *
   * @param functionName The name of the https callable function
   * @param data The request data for the callable function
   * @returns Promise which resolves to {@link OSKHttpsSuccessResponse} value with the given response type
   */
  public call<RequestDataType, ResponseDataType>(
    functionName: string,
    data?: RequestDataType
  ): Promise<OSKHttpsSuccessResponse<ResponseDataType>> {
    return httpsCallable<RequestDataType, OSKHttpsSuccessResponse<ResponseDataType>>(
      this.functions,
      functionName
    )(data).then((res) => {
      return res.data;
    });
  }
}
